import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Outlet, useLocation } from "react-router-dom";
import ROUTES from "constants/routes";
import AuthContainer from "components/AuthContainer";
import { HEADER_HEIGHT } from "constants/global";
import { NavigationHistoryProvider } from "context/navigationHistoryContext";
import { useMemo, useRef } from "react";
import withErrorBoundary from "hocs/withErrorBoundary";
import Header from "./Header";
import { MainLayoutContext } from "./context";

const MainLayout = () => {
  const location = useLocation();
  const isAuthPage = [ROUTES.USER_REGISTER, ROUTES.COMPANY_REGISTER, ROUTES.LOGIN].some((route) =>
    location.pathname.includes(route)
  );
  const mainBoxRef = useRef<HTMLDivElement>(null);

  const contextValue = useMemo(() => ({ mainBoxRef }), [mainBoxRef]);

  return (
    <NavigationHistoryProvider>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Header />
        <Box
          ref={mainBoxRef}
          component='main'
          sx={{
            backgroundColor: "#F6F8FF",
            flexGrow: 1,
            height: `calc(100vh - ${HEADER_HEIGHT})`,
            overflow: "auto",
          }}>
          <MainLayoutContext.Provider value={contextValue}>
            {isAuthPage ? (
              <AuthContainer>
                <Outlet />
              </AuthContainer>
            ) : (
              <Container
                maxWidth='xl'
                sx={{ mt: 2.5, mb: 2.5 }}>
                <Outlet />
              </Container>
            )}
          </MainLayoutContext.Provider>
        </Box>
      </Box>
    </NavigationHistoryProvider>
  );
};

export default withErrorBoundary(MainLayout);
